"use client";

import { useIsShopsite } from "@context/DomainContext";
import { IconButton as RadixIconButton } from "@radix-ui/themes";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { joinClassNames } from "@utils/helpers";
import { forwardRef } from "react";
import { useThemeContext } from "@utils/hooks";

export default forwardRef(function DialogCloseButton(
  {
    onClick,
    shopsiteVariant = "grey",
    className = "",
    disabled,
  }: {
    onClick?: () => void;
    shopsiteVariant?: "grey" | "white";
    className?: string;
    disabled?: boolean;
  },
  ref: React.Ref<HTMLButtonElement>
) {
  const isShopsite = useIsShopsite();
  const theme = useThemeContext();

  if (isShopsite) {
    return (
      <button
        ref={ref}
        disabled={disabled}
        onClick={onClick}
        className={joinClassNames(
          "w-8 h-8 rounded-full flex items-center justify-center transition-all duration-100 text-white opacity-100 disabled:opacity-0",
          shopsiteVariant === "grey"
            ? "bg-gray-400 hover:bg-gray-500"
            : "bg-white/10 hover:bg-white/15",
          className
        )}
      >
        <XMarkIcon className="h-4 w-4" />
      </button>
    );
  }

  return (
    <RadixIconButton
      disabled={disabled}
      ref={ref}
      variant="soft"
      radius={theme && theme.radius === "none" ? "none" : "full"}
      color="gray"
      onClick={onClick}
      className={joinClassNames(
        "cursor-pointer transition-opacity duration-200 ease-in-out opacity-100 disabled:opacity-0",
        className
      )}
    >
      <XMarkIcon className="h-5 w-5" />
    </RadixIconButton>
  );
});
